<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex flex-wrap items-end">
                <div class="flex-grow">
                    <vs-button v-if="isPermissionAdd()" @click="addPosition" color="primary" icon-pack="feather"
                        icon="icon-plus">
                        Thêm chức vụ
                    </vs-button>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh" ref="agGridTable" :components="components" :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                :defaultColDef="defaultColDef" :rowData="permisionsList" :animateRows="true" :pagination="true"
                :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                :paginationPageSize="paginationPageSize" :onGridReady="onGridReady" :suppressPaginationPanel="true">
            </ag-grid-vue>

            <div class="vx-row">
                <div class="vx-col w-full flex">
                    <div style="min-width:200px">
                        <span class="content-page font-bold">Hiển thị: </span><span class="text-page">{{ countElementPage
                                > totalElements ? totalElements : countElementPage
                        }} / {{ totalElements }} </span>
                    </div>
                    <vs-pagination :total="totalPages" :max="maxPageNumbers" @change="initScreen"
                        v-model="currentPage" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import Pagination from "../../../ui-elements/Pagination.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererContent from "./cell-renderer/CellRendererContent";
import { isRouter } from "../../../../store/permission";
import { constRouter } from "../../../../store/constant";

export default {
    components: {
        AgGridVue,

        // Cell Renderer
        Pagination,
        CellRendererActions,
        CellRendererContent
    },
    data() {
        return {
            countElementPage: 0,
            totalElements: 0,
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: 'ID',
                    field: 'id',
                    width: 30
                },
                {
                    headerName: 'Tên chức vụ',
                    field: 'name',
                    width: 100
                },
                {
                    headerName: 'Mô tả',
                    field: 'description',
                    width: 300
                },
                {
                    headerName: 'Hành động',
                    field: 'actions',
                    width: 80,
                    cellRendererFramework: 'CellRendererActions',
                },

            ],
            permisionsList: [],
            components: {
                CellRendererActions,
                CellRendererContent
            },
        }
    },
    created() {
        this.initScreen();
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.deleteNotification'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('DELETE_NOTIFY', false);
            }
        },
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        }
    },
    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.positinon_add)
        },
        addPosition() {
            this.$router.push('/user/add-position').catch(() => {
            })
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        initScreen() {
            this.$vs.loading();
            /*let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');*/
            this.$oauth.get('/position/find-all').then((response) => {
                this.permisionsList = response.data;
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
                this.countElementPage = this.currentPage * this.paginationPageSize;
                this.totalElements = this.permisionsList.length;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger',
                });
            });
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style scoped>

</style>
